module.exports = __webpack_public_path__ + "img/auto-optimize.6802b87c.svg";